<template>
  <div class="pageClass">
    <div style="display: flex;justify-content: space-between;">
      <div style="display: flex;">
        <el-button style="margin-right: 20px;" @click="importAuthBook" type="primary">授权书上报</el-button>
        <el-upload
          :limit="1"
          :action="uploadURL"
          :headers="headers"
          :show-file-list="false"
          :on-success="handleAvatarSuccess2"
          :on-error="handleAvatarError2"
          :before-upload="beforeAvatarUpload2"
          accept=".zip, .rar"
        >
          <el-button type="primary">授权书批量上报</el-button>
        </el-upload>
      </div>
      <div>
        <el-button @click="importAuthBook2" type="primary">授权书填报模板</el-button>
      </div>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column :show-overflow-tooltip="true" prop="enterpriseName" label="名称">
          <template slot-scope="{ row }">
            <span>{{ row.enterpriseName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传时间">
          <template slot-scope="{ row }">
            <span>{{ row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="{ row }">
            <span>{{ row.type === 1 ? '已审核' : '未审核' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="{ row }">
            <!-- <el-button @click="editUpload(row)" type="text">编辑</el-button>
            <span>|</span> -->
            <el-button @click="deletUpload(row)" type="text" v-if="row.auditStatus === '待审核'||row.auditStatus === '退回'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="text-align: right; margin-top:30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dataTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 上传与编辑弹窗 -->
    <div>
      <el-dialog
        @close="handleCloseDialog"
        :destroy-on-close="true"
        :title="bankTitle"
        :visible.sync="dialogUpload"
        width="50%"
      >
        <div>
          <div>
            <el-form :rules="rules" ref="formRef" :model="modeUploadForm" label-width="150px">
              <el-form-item label="企业名称:" prop="enterpriseName">
                <el-input v-model="modeUploadForm.enterpriseName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码:" prop="enterpriseCode">
                <el-input v-model="modeUploadForm.enterpriseCode" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="授权起止时间:" prop="creaTime">
                <el-date-picker
                  v-model="modeUploadForm.creaTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                prop="file"
                :rules="isEditMode ? editFileRules : rules.file"
                :label="`PDF或图片:${isEditMode ? '(必须替换)' : ''}`"
                :required="isEditMode"
              >
                <div v-if="isEditMode && existingFileName">
                  <span>当前文件: {{ existingFileName }} (如需更换请先删除原文件)</span>
                  <!-- <el-tag v-if="isEditMode" type="danger" size="small">必须替换</el-tag> -->
                  <el-button type="text" @click="removeExistingFile" icon="el-icon-delete">删除</el-button>
                </div>
                <div style="display: flex;">
                <el-upload
                  ref="uploadRef"
                  :file-list="fileArray"
                  :auto-upload="false"
                  action="#"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-change="handleFileChange"
                  :on-remove="handleRemove"
                  accept=".pdf, .jpg, .jpeg, .png, .gif"
                >
                  <el-button size="small" type="primary">{{ isEditMode ? '上传替换文件' : '选择文件' }}</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">
                    <p>只能上传单个 PDF 文件,大小不超过10MB</p>
                  </div> -->
                </el-upload>
                <a  href="/static/授权文件模板.docx" target="_blank" download ><span class="xiazaiClass">下载模板</span></a>
                </div>
              </el-form-item>
              <el-form-item>
                <img
                  :src="bankImageUrl"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitUpload">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import baseUrl from "@/api/baseUrl";
import {
  selectLicenseList,
  editUploads,
  editUploadDetail,
  uploadBankLicense,
  deletData
} from "../../../api/bankcrecenter.js";
import ZipCardUpload from "@/components/ZipCardUpload.vue";
export default {
  components: {
    ZipCardUpload,
  },
  data() {
    return {
      uploadURL: baseUrl + 'api/v1/bankLicense/uploadArchiveFile',
      headers: {
        token: sessionStorage.getItem('token')
      },
      showDialog: false,
      bankFromPage: {
        page: 1,
        pageSize: 10
      },
      bankImgArr:[
        {bankName:"中国工商银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/zggsyh.png"),bankCode:"9132050060821340XJ"},
        {bankName:"中国农业银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/zgnyyh.png"),bankCode:"91320500837748926Q"},
        {bankName:"中国银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/zhongguoyh.png"),bankCode:"91320500837691819W"},
        {bankName:"中国建设银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/zgjsyh.png"),bankCode:"91320594837700981U"},
        {bankName:"交通银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/jiaotongyh.png"),bankCode:"91320594837701677K"},
        {bankName:"招商银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/zsyh.png"),bankCode:"9132059471857525XK"},
        {bankName:"上海浦东发展银行股份有限公司苏州分行	",bankImage:require("../../../assets/qrcodes/pufayh.png"),bankCode:"91320594837756678H"},
        {bankName:"浙商银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/zhesyh.png"),bankCode:"9132059459855228XB"},
        {bankName:"上海银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/shanghaiyh.png"),bankCode:"913205945653373130"},
        {bankName:"江苏银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/jiangsuyh.png"),bankCode:"91320594798305865H"},
        {bankName:"苏州银行股份有限公司	",bankImage:require("../../../assets/qrcodes/suzhouyn.png"),bankCode:"91320000768299855B"},
        {bankName:"宁波银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/ningboyh.png"),bankCode:"9132059468715251XX"},
        {bankName:"江苏常熟农村商业银行股份有限公司苏州分行	",bankImage:require("../../../assets/qrcodes/changshuyh.png"),bankCode:"91320594MA1P8B7D6Q"},
        {bankName:"江苏苏州农村商业银行股份有限公司",bankImage:require("../../../assets/qrcodes/suzhounsyh.png"),bankCode:"91320500251317395W"},
        {bankName:"中国邮政储蓄银行股份有限公司苏州市分行",bankImage:require("../../../assets/qrcodes/zgyzyh.png"),bankCode:"91320594673924144X"},
        {bankName:"江苏张家港农村商业银行股份有限公司",bankImage:require("../../../assets/qrcodes/zjgnsh.png"),bankCode:"91320000732252238K"},
        {bankName:"南京银行股份有限公司苏州分行",bankImage:require("../../../assets/qrcodes/nanjingyh.png"),bankCode:"91320594566848027E"},
        {bankName:"江苏太仓农村商业银行股份有限公司	",bankImage:require("../../../assets/qrcodes/taicangyh.png"),bankCode:"91320500770509807Q"},
        {bankName:"中国人民财产保险股份有限公司苏州市分公司",bankImage:require("../../../assets/qrcodes/zgrbcx.png"),bankCode:"913205058377495238"}
      ],
      dataTotal: null,
      created: "",
      tableData: [],
      dialogUpload: false,
      isEditMode: false, //编辑模式
      bankTitle: "",
      bankImageUrl: "",
      currentId: null, // 当前编辑的ID
      fileArray: [],
      modeUploadForm: {
        enterpriseName: "",
        enterpriseCode: "",
        creaTime: [],
        file: null,
        rawFile: null
      },
      rules: {
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        enterpriseCode: [
          { required: true, message: "请输入信用代码", trigger: "blur" }
        ],
        creaTime: [
          {
            type: "array",
            required: true,
            message: "请选择日期",
            trigger: "blur"
          }
        ],
        file: [{ required: true, message: "请上传文档文件", trigger: "change" }]
      },
      editFileRules: [{ validator: this.validateFiles, trigger: "change" }],
      existingFileName: null,
      isFileDeleted: false //标记文件是否删除状态
    };
  },
  mounted() {
    this.created = sessionStorage.getItem("userName") || "未知用户";
    this.getBankList();
    console.log(this.organization);
  },
  computed: {
    organization: function() {
      return this.$store.getters.organization;
    }
  },
  methods: {
    // 上传成功（HTTP 2xx）
    handleAvatarSuccess2 (res) {
      if (res && res.code === 200) {
        this.$message.success(res.msg || '上传成功');
        this.getBankList();
      } else {
        this.$message.error((res && res.msg) || '上传失败');
      }
    },
    // 上传失败（网络错误 / HTTP 非 2xx）
    handleAvatarError2 (err) {
      const msg = (err && err.message) || '网络异常，上传失败，请稍后重试';
      this.$message.error(msg);
    },
    // 上传之前
    beforeAvatarUpload2 (file) {
      const isZip = file.type === 'application/zip' || file.type === 'application/x-rar-compressed' || file.name.endsWith('.zip') || file.name.endsWith('.rar');
      if (!isZip) {
        this.$message.error('只允许上传 ZIP 或 RAR 文件');
        return false; // 阻止文件上传
      }
      return true;
    },
    showUpload(){
      this.showDialog = true;
    },
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isExcel) {
        this.$message.error('只允许上传 Excel 文件');
        return false; // 阻止文件上传
      }
      return true; // 允许文件上传
    },
    // 获取银行列表
    async getBankList() {
      const res = await selectLicenseList({
        ...this.bankFromPage,
        created: this.created
      });
      this.tableData = res.data.data;
      this.dataTotal = res.data.data.size;
    },
    // 银行授权书
    importAuthBook() {
      this.bankTitle = "授权书上报";
      this.dialogUpload = true;
      var imageCode = sessionStorage.getItem("organization");
      this.bankImgArr.forEach(item=>{
        if(item.bankCode == imageCode){
          this.bankImageUrl = item.bankImage;
          return
        }
      })
      this.isEditMode = false;
    },
    // 自定义文件验证（编辑模式）
    validateFiles(rule, value, callback) {
      if (this.isEditMode) {
        // 编辑模式：必须上传新文件
        this.fileList.length > 0
          ? callback()
          : callback(new Error("必须上传新文件替换原文件"));
      } else {
        // 新增模式下必须有文件
        if (this.fileList.length > 0) {
          callback();
        } else {
          callback(new Error("请上传PDF文件"));
        }
      }
    },
    // 编辑获取详情
    async editUpload(row) {
      const res = await editUploadDetail({ id: row.id });
      //   console.log(res, "idid");
      this.bankTitle = "编辑授权书";
      this.isEditMode = true;
      this.currentId = row.id;
      this.existingFileName = res.data.data.licensePath || "";
      this.isFileDeleted = false; // 重置删除状态
      this.$nextTick(() => {
        this.modeUploadForm = {
          enterpriseName: row.enterpriseName,
          enterpriseCode: row.enterpriseCode,
          creaTime: [row.authorizedStartTime, row.authorizedEndTime],
          file: null
        };
      });
      this.fileList = []; // 清空上传文件列表
      this.dialogUpload = true;
    },
    // 删除已有文件
    removeExistingFile() {
      this.existingFileName = "";
      this.isFileDeleted = true;
      this.$refs.formRef.validateField("file"); // 重新验证文件字段
    },
    handleCloseDialog2(){
      this.showDialog = false;  
    },
    // 关闭弹窗重置
    handleCloseDialog() {
      this.$refs.formRef.resetFields();
      this.$refs.uploadRef.clearFiles();
      this.fileArray = [];
      this.existingFileName = null;
      this.modeUploadForm = {
        enterpriseName: "",
        enterpriseCode: "",
        creaTime: ""
      };
    },
    importAuthBook2() { 
      //下载static文件夹下的授权文件填写样例.docx文件
      const link = document.createElement("a");
      link.href = "/static/授权文件填写样例.docx";
      link.download = "授权文件填写样例.docx";
      link.click();
      document.body.removeChild(link);
    },
    // 文件变化处理
    handleFileChange(file, fileList) {
      if (!file) return;
      const extension = (file.name.split(".").pop() || "").toLowerCase();
      const isTypeValid =
        [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "image/jpeg",
          "image/png",
          "image/gif"
        ].includes(file.type) || ["pdf", "doc", "docx", "jpg", "jpeg", "png", "gif"].includes(extension);
      if (!isTypeValid) {
        this.$message.error("文件格式不支持");
        this.$refs.uploadRef.clearFiles();
        return;
      }
      // 验证文件大小;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("文件超过10MB限制");
        this.$refs.uploadRef.clearFiles();
        return;
      }
      if (fileList.length > 1) {
        fileList.shift();
      } else {
        this.modeUploadForm.file = null;
        this.modeUploadForm.rawFile = null;
      }
      this.fileList = fileList;
      this.modeUploadForm.file = file.raw;
      this.existingFileName = "";
      this.$refs.formRef.validateField("file");
    },

    // 文件移除处理
    handleRemove(file, fileList) {
      //   this.modeUploadForm.file = null;
      //   this.modeUploadForm.rawFile = null;
      //   console.log(fileList, "fileList");

      this.fileList = fileList;
      this.modeUploadForm.file = null;
      this.$refs.formRef.validateField("file");
    },

    // 文件超出限制
    handleExceed() {
      this.$message.warning("只能上传一个文件，请先移除当前文件");
    },
    // 确定提交上传接口方法
    async submitUpload() {
      try {
        const valid = await this.$refs.formRef.validate();
        if (!valid) return;
        // 编辑模式下必须上传新文件
        if (this.isEditMode && !this.modeUploadForm.file) {
          this.$message.error("必须上传新文件替换原文件");
          return;
        }
        const formData = new FormData();
        formData.append("enterpriseName", this.modeUploadForm.enterpriseName);
        formData.append("enterpriseCode", this.modeUploadForm.enterpriseCode);
        formData.append("authorizedStartTime", this.modeUploadForm.creaTime[0]);
        formData.append("authorizedEndTime", this.modeUploadForm.creaTime[1]);
        formData.append("created", this.created);
        formData.append("organization", this.organization);
        // 只有有新文件时才上传;
        // if (this.modeUploadForm.rawFile) {
        //   //   formData.append("file", this.form.pdfFile);
        //   formData.append("file", this.modeUploadForm.rawFile);
        // }
        if (this.isEditMode) {
          console.log(this.isEditMode, "isEditMode");
          formData.append("id", this.currentId);
          formData.append("originalFileName", this.existingFileName.name);
          if (this.fileList.length > 0) {
            // 有新上传的文件
            formData.append("file", this.modeUploadForm.file);
            if (this.existingFileName) {
              formData.append("removeExisting", "true");
            }
          } else if (this.isFileDeleted && this.existingFileName) {
            // 删除了原文件且没有上传新文件
            formData.append("removeExisting", "true");
          }
          //   编辑接口
          const res = await editUploads(formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });
          if (res.data.code == 200) {
            this.$message.success(`编辑${res.data.msg}`);
            this.getBankList();
            this.dialogUpload = false;
          } else {
            this.$message.error(`编辑${res.data.msg}`);
          }
        } else {
          if (this.fileList.length > 0) {
            formData.append("file", this.modeUploadForm.file);
            // 调用新增接口
            const res = await uploadBankLicense(formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            });
            if (res.data.code == 200) {
              this.$message.success(`新增${res.data.msg}`);
              this.getBankList();
              this.dialogUpload = false;
            } else {
              this.$message.error(`新增${res.data.msg}`);
            }
          }
        }
      } catch (error) {
        console.error("提交失败:", error);
        // this.$message.error(error.res?.data?.message || "文档提交失败");
      }
    },
    // 删除
    async deletUpload(row) {
      //确认删除
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await deletData({ id: row.id });
        if (res.data.code == 200) {
        this.$message.success(`删除${res.data.msg}`);
        this.getBankList();
      } else {
        this.$message.error(`删除${res.data.msg}`);
        this.getBankList();
      }
      }).catch(() => {
        this.$message.info("已取消操作");
      });
    },
    // 分页
    handleSizeChange(val) {
      this.bankFromPage.pageSize = val;
      this.getBankList(this.bankFromPage);
    },
    handleCurrentChange(val) {
      this.bankFromPage.page = val;
      this.getBankList(this.bankFromPage);
    }
  }
};
</script>

<style lang="less" scoped>
.pageClass{
  .xiazaiClass{
    margin-left: 20px;
    background-color: #2981ee;
    border-color: #2981ee;
    color: #fff;
    font-size: 12px;
    border-radius: 3px;
    padding: 9px 15px;
    &:hover{
      background: rgb(83.8, 154.2, 241.4);
      border-color: rgb(83.8, 154.2, 241.4);
      color: #fff;
    }
  }
}
</style>